// @ts-strict

import { Component, OnInit, Input, ElementRef } from '@angular/core';
import { IDeviceType, ICategoryType } from '@app/core/index';

@Component({
  selector: 'app-categories-or-countries',
  templateUrl: './categories-or-countries.component.html',
  styleUrls: ['./categories-or-countries.component.scss']
})
export class CategoriesOrCountriesComponent implements OnInit {
  @Input() index?: number;
  @Input() mode: string = '';
  @Input() layout: string = '';
  @Input() forceInactive = false;
  @Input() watchInactive = false;
  @Input() item?: IDeviceType | ICategoryType;
  @Input() tooltipContainer = 'body';

  @Input() updateDecision!: (isActive: boolean, countryId: number) => void;

  constructor(private elementRef: ElementRef<HTMLElement>) {}

  public notOverflowed = true;

  public get isListLayout(): boolean {
    return this.layout === 'list';
  }

  public get istilesaltComponent(): boolean {
    return this.layout === 'tiles-alt';
  }

  public get tilesLayout(): boolean {
    return this.layout === 'tiles';
  }

  ngOnInit(): void {
    const element = this.elementRef.nativeElement;
    if (element.offsetWidth > 120) {
      this.notOverflowed = false;
    }
  }
}
